import { WarningAlt } from '@mint-lib/icons';
import {
  Card,
  FeaturedIcon,
  typographyVariants,
} from '@mint-lib/tw-components';

function ExpiredRouteComponent() {
  return (
    <Card
      hover={'noHover'}
      className="flex h-[50vh] w-212.5 items-center justify-center overflow-hidden px-13"
      contentClassName="p-0"
    >
      <div className={'flex flex-col items-center justify-center gap-8'}>
        <div className={'flex flex-col items-center justify-center gap-4'}>
          <FeaturedIcon icon={<WarningAlt />} className={'h-16 w-16'} />
          <h2
            className={typographyVariants({ variant: 'h2', color: 'primary' })}
          >
            Recommendation expired
          </h2>
        </div>
        <p
          className={typographyVariants({
            variant: 'bodyLong02',
            color: 'secondary',
          })}
        >
          The recommendation you are looking for expired because a new one is
          already available.
        </p>
      </div>
    </Card>
  );
}

export default ExpiredRouteComponent;
